module.exports = {
	'shift.hp.m3.m310410_inspection.group_config_dialog': {
		'selectAGroupClass': '選擇群組班別',
		'selectALabel': '選擇標籤',
	},
	'shift.hp.m3.m310410_inspection.inspect_config': {
		'selectedClass': '已選班別',
		'theFileFormatIsIncorrect': '檔案格式錯誤',
		'postsShouldBeRearrangedForManpower': '崗位應排人力匯入',
	},
	'shift.m4.m410210': {
		'saveAndSubmitSchedules': '儲存並提交班表',
		'scheduleStatus': '班表狀態',
		'previewStatus': '預排狀態',
	},
	'shift.am.Shifting': {
		'workingHours': '工作時間',
		'breaks': '休息時間',
	},
	'shift.am.ShiftingFieldSetting': {
		'theNumberOfBlockedColumnsCannot': '凍結的欄位數不可超過 10 個',
		'open': '開啟',
		'theLeftSideFreezes': '左側凍結',
		'theRightSideFreezes': '右側凍結',
	},
	'ai-shift.m3.m310410_ai_shift.dialog': {
		'manpowerAllocation': '人力配置',
		'staffScheduling': '員工預排',
		'generatingYourScheduleData': '正在幫你生成班表資料...',
		'byUnderstandingYourSchedulingConsiderationsI': '透過了解你的排班考量，我會快速生成班表，請先告訴我你的考量？',
		'aISchedulingConsiderations': 'AI 排班考量',
		'minimumCost': '最低成本',
		'averageWorkingHours': '工時平均',
		'mustMeetTheRequirements': '需符合條件',
		'startGeneratingTheSchedule': '開始生成班表',
		'downloadGeneratedResults': '下載生成結果',
		'workingHoursRegulations': '工時規則',
		'employeeManagement': '員工管理',
		'humanResourceAllocation2': '人力配置',
		'workingHoursRegulationsHint': '選填，建議勾選，讓 AI 在排班時即納入工時規則規範。若未勾選，系統仍會在「儲存班表」時再次檢核工時規格。',
		'aISchedulingBasisAndDataUsageScope': 'AI 排班依據與資料使用範圍',
		'schedulingIsBasedOnlyOnResourceAllocation': '排班僅依「人力配置、員工可上班時間、標籤、工時規則、員工預排」進行。系統不會蒐集或使用可上班時間背後的原因（如懷孕、宗教、健康或家庭照顧因素）作為排班依據。',
	},
	'ai-shift.m3.m310410_ai_shift.resource_allocation': {
		'editManpowerAllocation': '編輯人力配置',
		'queryManpowerAllocation': '查詢人力配置',
		'yYYYMMDD': 'YYYY年MM月DD日',
		'person': '人',
	},
	'ai-shift.m3.m310410_new': {
		'aIHelpsYouScheduleShifts': 'AI 幫你排班',
		'rescheduleAIShifts': '重新 AI 排班',
		'differenceDate': '差異日期',
	},
	'ai-shift.m3.m310410_shifting': {
		'whyGenerateThisScheduleForYou': '為何生成這個班表給你',
		'basedOnYourSchedulingConsiderationsFor': '根據您選擇的參數，我們為你排定了這個班表。此班表與你的需求高度合適，綜合考量了員工管理、人力配置、工時規則、員工預排，讓整體排班更公平且合法。',
	},
	'ai-shift.m3.m310320_grid': {
		'theDataHasBeenDeletedAnd': '資料已被刪除，不可儲存。',
		'overnightShiftsOnlyDisplayTheCurrent': '跨夜班次僅顯示當日時段，AI 排班會依完整時段排班。',
		'forShiftsThatSpanOvernightE': '班別為跨夜班次（如：前日 20:00 至當日 04:00），畫面將僅顯示當日部分（00:00 - 04:00）。請放心，AI 自動排班仍會依據完整時段進行邏輯計算，不影響實際排班結果。',
	},
	'ai-shift.m3.m310320': {
		'groupsCannotBeDuplicated': '群組不可重複',
	},
	'ai-shift.service.m3.service-m310320': {
		'theCurrentlySelectedClassIsNo': '目前選取的<%=temp1%>已不適用，請重新選取有效班別並儲存。',
	},
	'ai-shift.service.m3.service-m310410-ai-shift': {
		'whenTheNumberOfScheduledPersonnel': '當排班人數超過 100 人時，為了確保排班效率與最佳化結果，暫不建議直接使用 AI 自動排班功能。',
		'beforeAIHelpsYouScheduleYou': 'AI幫你排班前，需要先設定人力配置資料。\n請至人力配置，設定至少一天的需求人力。',
		'insufficientManpowerToScheduleShiftsPlease': '人力不足無法排班\n請調整人力配置',
		'lackingEmployeesWith': '缺乏具備 <%=temp1%> 的員工',
		'aSystemEnvironmentErrorHasOccurred': '系統環境發生錯誤，請聯絡104 HR Max FAE工程師。',
	},
	'ai-shift.m3.m310410_ai_shift.compare': {
		'datesWithDifferencesBetweenAIScheduling': 'AI 排班結果與人力配置有差異的日期',
	},
};
